var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"not-found"},[_c('h1',{staticClass:"not-found__title"},[_vm._v("Whoa.")]),_c('p',[_vm._v("\n    The page you were looking for disappeared. Bug Zac on where to find that page!\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }